import { DataTrackingClient } from "./core";
import { Logger, LogLevel } from "./utils/logger";
let objDataTrackingClient = null;
export const __VERSION__ = require('../package.json').version;
export const dataAttributePrefix = "data-dtdynamic-";
export const cookiePrefix = "data_tracking_";
export const sessionCookieName = "session_id_client";
export const sessionServerCookieName = "session_id_server";
export const uidCookieName = "uid_client";
export const uidServerCookieName = "uid_server";
export const campaignKeyCookieName = "campaign_key_client";
export const formSubmissionCookieName = "datatracking-form-submission";
export function init(apiHost, domainUDID, userIdentity, arbibaryData, logging = false, logLevel = LogLevel.VERBOSE) {
    Logger.verbose("Initializing data tracking. Library version " + __VERSION__);
    Logger.consoleLogging = logging;
    Logger.logLevel = logLevel;
    try {
        objDataTrackingClient = new DataTrackingClient(apiHost, domainUDID, userIdentity, arbibaryData);
    }
    catch (err) {
        Logger.error("Could not create instance of DataTrackingClinet");
        Logger.error(err);
        return;
    }
    objDataTrackingClient.init();
}
export function addGoalURL(objGoalUrl) {
    if (!objDataTrackingClient)
        return;
    objDataTrackingClient.addGoalUrl(objGoalUrl);
}
export function track(whatToTrack, elementSelector, parentSelector, eventName, trackingAttributes, group, trackingProperties, trackingCookies, formConfig, ajaxConfig, elementId, goalId) {
    if (!objDataTrackingClient)
        return;
    let trackingElement = {
        whatToTrack: whatToTrack,
        elementSelector: elementSelector,
        parentSelector: parentSelector,
        eventName: eventName,
        trackingAttributes: trackingAttributes,
        group: group,
        trackingProperties: trackingProperties,
        trackingCookies: trackingCookies,
        formConfig: formConfig,
        ajaxConfig: ajaxConfig,
        elementId: elementId,
        goalId: goalId
    };
    Logger.verbose("Adding tracking element");
    Logger.verbose(JSON.stringify(trackingElement));
    objDataTrackingClient.addItemToTrack(trackingElement);
}
